var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "14",
        viewBox: "0 0 14 14",
        width: "14",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { fill: "#FFF", "fill-rule": "nonzero" } }, [
        _c("path", {
          attrs: {
            d: "M8.556 0v1.556h2.788L3.698 9.2l1.1 1.1 7.646-7.645v2.788H14V0z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M12.444 12.444H1.556V1.556H7V0H1.556C.696 0 0 .696 0 1.556v10.888C0 13.304.696 14 1.556 14h10.888c.86 0 1.556-.696 1.556-1.556V7h-1.556v5.444z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }